<template>
  <v-dialog
    v-model="visible"
    persistent
    width="350"
    height="689"
    content-class="my-custom-dialog"
  >
    <v-overlay v-if="loading" absolute style="z-index: 1000">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>
    <v-form ref="registerForm" @submit.prevent="submit">
      <v-card :class="{ 'mobile-card': $vuetify.breakpoint.smAndDown, 'register-dialog-card': true }">
        <div class="register-dialog-title">
          <v-icon left color="white" size="32">mdi-account-plus</v-icon>
          <span class="register-dialog-title-text">Registracija</span>
        </div>
        <v-card-text class="pt-6">
          <v-row class="mb-1">
            <v-col cols="12" class="pb-0 mb-0 pt-0 mt-0">
              <v-text-field
                outlined
                dense
                :label="$t('$vuetify.formDetails.firstName')"
                prepend-inner-icon="mdi-account"
                class="register-input"
                :rules="[rules.req]"
                v-model="name"
                autofocus
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-1">
            <v-col cols="12" class="pb-0 mb-0 pt-0 mt-0">
              <v-text-field
                :label="$t('$vuetify.formDetails.lastName')"
                prepend-inner-icon="mdi-account"
                outlined
                dense
                class="register-input"
                :rules="[rules.req]"
                v-model="lastName"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-1">
            <v-col cols="12" class="pb-0 mb-0 pt-0 mt-0">
              <v-text-field
                label="Email"
                prepend-inner-icon="mdi-email"
                outlined
                dense
                :rules="[rules.req, rules.email]"
                v-model="email"
                class="register-input"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-1">
            <v-col cols="12" class="pb-0 mb-0 pt-0 mt-0">
              <v-text-field
                outlined
                :label="$t('$vuetify.formDetails.password')"
                prepend-inner-icon="mdi-lock"
                v-model="password"
                :rules="passwordRules"
                :type="passVisible ? 'text' : 'password'"
                :append-icon="passVisible ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (passVisible = !passVisible)"
                dense
                class="register-input"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-1">
            <v-col cols="12" class="pb-0 mb-0 pt-0 mt-0">
              <v-text-field
                outlined
                :label="$t('$vuetify.formDetails.confirmPassword')"
                prepend-inner-icon="mdi-lock"
                v-model="confirmPassword"
                dense
                :rules="[
                  rules.eq(
                    password,
                    `${$t('$vuetify.formDetails.passwordMatchRule')}`
                  ),
                  rules.req,
                ]"
                :type="confirmPassVisible ? 'text' : 'password'"
                :append-icon="confirmPassVisible ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (confirmPassVisible = !confirmPassVisible)"
                class="register-input"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-1">
            <v-col cols="12" class="pb-0 mb-0 pt-0 mt-0">
              <v-text-field
                label="Broj telefona"
                prepend-inner-icon="mdi-cellphone-information"
                outlined
                dense
                :rules="[rules.req]"
                v-model="phoneNumber"
                class="register-input"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0 pb-0 mb-0 pt-0 mt-0">
              <a
                href="https://www.aikasa.app/legal/uvjeti"
                target="_blank"
                >{{ $t("$vuetify.formDetails.terms") }}</a
              >
            </v-col>
          </v-row>
          <v-row class="pb-0">
            <v-col class="pb-0 mb-0 pt-0 mt-0">
              <v-checkbox
                v-model="terms"
                color="primary"
                :rules="[rules.req]"
                hide-details
                dense
                :label="$t('$vuetify.formDetails.termsAgree')"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pr-5 pb-6 pl-10">
          <v-spacer></v-spacer>
          <v-btn class="register-cancel-btn" @click="close" elevation="0">
            <v-icon left small>mdi-close</v-icon>
            Odustani
          </v-btn>
          <v-btn
            id="success"
            class="register-submit-btn ml-2"
            :loading="submitting"
            type="submit"
            elevation="0"
          >
            <v-icon left small>mdi-check</v-icon>
            {{ $t("$vuetify.formDetails.register") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import rules from '@/plugins/rules'
import { registerUser } from '@/api/default'
export default {
  name: 'Register',
  computed: {
    passwordRules () {
      return [
        rules.req(),
        rules.validPass([this.name, this.lastName, this.email])
      ]
    }
  },
  data: () => ({
    visible: false,
    loading: false,
    passVisible: false,
    confirmPassVisible: false,
    name: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    password: '',
    confirmPassword: '',
    terms: false,
    submitting: false,
    error: {
      show: false,
      message: undefined
    },
    rules: {
      req: rules.req(),
      eq: rules.eq,
      email: rules.email()
    }
  }),
  inject: ['showMsgBox'],
  methods: {
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
      this.$refs.registerForm.reset()
    },
    async submit () {
      if (!this.$refs.registerForm.validate()) return
      this.loading = true
      try {
        const owner = {
          email: this.email,
          name: this.name.trim(),
          surname: this.lastName.trim(),
          password: this.password,
          password_confirmation: this.confirmPassword,
          agree_terms_of_use: this.terms ? 'YES' : 'NO',
          phone_number: this.phoneNumber
        }
        const resp = await registerUser({
          action: {
            operation: 'set',
            entity: 'owner',
            params: {
              owner: owner
            }
          }
        })
        if (resp.data && resp.data.header) {
          if (resp.data.header.code !== 200) {
            this.error.show = true
            this.error.message = resp.data.header.error
            this.showMsgBox({
              text: resp.data.header.error,
              actions: ['cancel'],
              cancelBtnText: this.$t('$vuetify.close'),
              color: 'error'
            })
          } else {
            this.showMsgBox({
              text: this.$t('$vuetify.registerSuccessMsg'),
              actions: ['cancel'],
              cancelBtnText: this.$t('$vuetify.close'),
              color: 'info'
            })
            this.close()
          }
        }
      } catch (error) {
        this.error.show = true
        this.error.message = error
      } finally {
        this.loading = false
      }
    },
    dismissError () {
      this.error.show = false
      this.error.message = undefined
    }
  }
}
</script>
<style scoped>
/* Register Dialog Card */
.register-dialog-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.12) !important;
}

/* Register Dialog Title */
.register-dialog-title {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  padding: 24px !important;
  display: flex !important;
  align-items: center !important;
  position: relative;
}

.register-dialog-title::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
  pointer-events: none;
}

.register-dialog-title-text {
  color: white !important;
  font-weight: 700 !important;
  font-size: 20px !important;
  letter-spacing: 0.5px !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
}

/* Register Input Fields */
.register-input {
  min-height: auto !important;
}

.register-input >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 8px !important;
}

.register-input >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.register-input:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.register-input.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.register-input.error--text >>> fieldset {
  border-color: #F44336 !important;
  border-width: 2px !important;
}

.register-input.error--text >>> .v-input__slot {
  background: rgba(244, 67, 54, 0.05) !important;
}

.register-input >>> .v-icon {
  color: rgba(57, 137, 201, 0.7) !important;
}


/* Register Submit Button - Soft Success Style */
.register-submit-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #4CAF50 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(76, 175, 80, 0.15) !important;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 0 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.register-submit-btn:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.25) !important;
  border-color: rgba(76, 175, 80, 0.3) !important;
  transform: translateY(-1px);
}

.register-submit-btn .v-icon {
  color: #4CAF50 !important;
  font-size: 18px !important;
}

/* Register Cancel Button - Soft Danger Style */
.register-cancel-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #F44336 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(244, 67, 54, 0.15) !important;
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  padding: 0 18px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.register-cancel-btn:hover {
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.25) !important;
  border-color: rgba(244, 67, 54, 0.3) !important;
  transform: translateY(-1px);
}

.register-cancel-btn .v-icon {
  color: #F44336 !important;
  font-size: 18px !important;
}
</style>
